import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SliderModule } from 'src/app/components/slider/slider.module';
import { MaterialModule } from '../../app.material.module';
import { ButtonModule } from '../../components/button/button.module';
import { InViewModule } from "../../components/in-view/in-view.module";
import { LandschapComponent } from '../../components/landschap/landschap.component';
import { ContentModule } from '../../services/content/content.module';
import { AccountComponent } from './account/account.component';
import { HomePageComponent } from './home-page.component';
import { LaneComponent } from './lane/lane.component';
import { TestimonialComponent } from './testimonial/testimonial.component';
import { TwocolumnComponent } from './twocolumn/twocolumn.component';

const routes: Routes = [
  {
    path: '',
    component: HomePageComponent
  }
];

@NgModule({
  declarations: [HomePageComponent, LandschapComponent, TestimonialComponent, TwocolumnComponent, AccountComponent, LaneComponent],
  imports: [CommonModule, MaterialModule, InViewModule, RouterModule.forChild(routes), ContentModule, ButtonModule, SliderModule],
  exports: [HomePageComponent]
})
export class HomePageModule {}
